<template>
  <div class="makc">
    <img class="makc__logo" src="@/create/assets/icons/logo-square.svg">
    <div class="makc__block">
      <p class="makc__title">МАКС-Жизнь страховая компания</p>
      <h1 class="makc__subtitle">{{ title }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title']
}
</script>
<style lang="scss" scoped>
@import "@/create/assets/scss/style.scss";

.makc {
  display: flex;
}
</style>
